import { authApi } from '@/api/auth';
import { useAuthStore } from '@/store';
import { usePlatformNavStore } from '@/store/usePlatformNavStore';

/**
 * 拉取 /me 写入本地；运营后台动态侧栏依赖 getSidebar 缓存，须强制重拉后才与角色菜单一致。
 */
export async function refreshSessionFromServer(): Promise<void> {
  try {
    const { data } = await authApi.me();
    useAuthStore.getState().updateUser(data);
    if (data.role === 'admin') {
      await usePlatformNavStore.getState().loadPlatformNav(true);
    }
  } catch {
    /* 保持现状 */
  }
}
